import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-view-user-for-instance-modal',
    templateUrl: './view-user-for-instance-modal.component.html',
    styleUrls: ['./view-user-for-instance-modal.component.scss'],
})
export class ViewUserForInstanceModalComponent {
    @Input() instanceuser: any;
    @Input() modalMode: string;

    constructor(private ngbActiveModal: NgbActiveModal) {}

    closeAddUSerModal() {
        this.ngbActiveModal.close(false);
    }
}
